import { Flex } from '@indoqa/style-system';
import * as React from 'react';
import { withUIETheme } from '../uietheme/withUIETheme';
const MenuHeader = ({ children, uieTheme }) => {
    const style = {
        boxSizing: 'border-box',
        height: uieTheme.layout.topMenuHeight,
        paddingRight: uieTheme.spacing.space4,
    };
    return (React.createElement(Flex, { fullWidth: true, style: style, alignItems: "center", justifyContent: "space-between" }, children));
};
export default withUIETheme(MenuHeader);
//# sourceMappingURL=MenuHeader.js.map